import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { TIME_API } from "@constants/api";
import dayjs from "dayjs";

export const GlobalTime = types
  .model({
    time: types.maybeNull(types.number),
  })
  .actions((self) => ({
    getTimeGlobal: flow(function* getTimeGlobal() {
      const beforeTime = dayjs(new Date().getTime()).unix();
      try {
        // ... yield can be used in async/await style
        const result = yield axios.get(TIME_API);
        self.time = result?.data?.now
          ? Math.round(
              result.data.now + dayjs(new Date().getTime()).unix() - beforeTime
            )
          : dayjs(new Date().getTime()).unix();
      } catch (error) {
        self.time = dayjs(new Date().getTime()).unix();
      }
    }),
  }));
